"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("../..");
const Legend_1 = __importDefault(require("../../Legend/Legend"));
const Checkbox_1 = __importDefault(require("../Checkbox"));
function CheckboxGroup({ children, error, id, tile }) {
    let label;
    const options = [];
    (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children)).forEach((child) => {
        const componentType = (0, react_1.isValidElement)(child) ? child?.type : undefined;
        switch (componentType) {
            case Legend_1.default:
                label = child;
                break;
            case Checkbox_1.default:
                options.push(child);
                break;
            default:
                throw new Error(`Invalid child component '${componentType}' used in CheckboxGroup.`);
        }
    });
    if (!label) {
        throw new Error('A Legend is required inside of a CheckboxGroup.');
    }
    if (!options.length) {
        throw new Error('At least one Checkbox must be present inside of a CheckboxGroup.');
    }
    return ((0, jsx_runtime_1.jsxs)(__1.Fieldset, { children: [(0, react_1.cloneElement)(label, { error }), (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), options.map((child, index) => {
                const el = child;
                if ((0, react_1.isValidElement)(el)) {
                    return (0, react_1.cloneElement)(el, {
                        groupIndex: index,
                        id,
                        tile
                    });
                }
                return el;
            })] }));
}
exports.default = CheckboxGroup;
